import { ProductSubCategoryListPage } from "@/features/product-sub-category/pages/ProductSubCategoryListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-sub-category/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_sub_category.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductSubCategoryListPage,
});
